import { useTranslation } from 'react-i18next';
import { Spacing4 } from 'autogen/design-tokens/tokens';
import { ShowFilters } from 'autogen/translation-keys/trans-website-filter';
import ButtonWithActiveState from 'components/Button/ButtonWithActiveState';
import Icon from 'components/Icon';
import Flex from 'components/Layout/components/Flex';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import { rootMenuId } from './RootFilterMenu';

/**
 * RootFilter. the main filter menu that displays all the sub filter menus
 * @param param0
 * @returns
 */
export default function RootFilterMenuOpener({ activeFilterValues, ...restProps }) {
    const { openFilterMenu } = useFilterMenu(rootMenuId);
    const { t } = useTranslation();
    return (
        <ButtonWithActiveState.WithIcon
            icon={<Icon type="Filter" size={16} />}
            size="lg"
            onClick={openFilterMenu}
            isActive={!!activeFilterValues.length}
            {...restProps}
        >
            <Flex.Row alignItems="center" gap={Spacing4}>
                <b>{t(ShowFilters)}</b>
                {!!activeFilterValues.length && <b>({activeFilterValues.length})</b>}
            </Flex.Row>
        </ButtonWithActiveState.WithIcon>
    );
}
